import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Task } from '@task-utils/types';
import { language, progress } from 'curvy';
import { Comments } from './comments';
import { comments_translations } from './comments.trans';
import { User } from '@task-modules/users';

type CommentTab = "internal" | "public";

const MANAGER_TYPES: Task.USER_TYPE[] = [
  Task.USER_TYPE.SYSTEM_ADMIN,
  Task.USER_TYPE.ADMIN,
  Task.USER_TYPE.SECTOR_ADMIN,
  Task.USER_TYPE.REGIONAL_MAINTENANCE_MANAGER,
  Task.USER_TYPE.SAFETY_MANAGER,
];

@Component({
  selector: 'task-new-comments',
  templateUrl: './comments-new.component.html',
  styleUrls: ['./comments-new.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommentsNewComponent implements OnChanges {
  @ViewChild('commentscontainer')
  comments_container: any = ElementRef;

  @Input()
  entity: Task.ENTITY;
  @Input()
  entity_id: number;
  @Input()
  main_company_id:number;

  comments: Task.Comment[] = [];
  comment_text = '';
  show_public_info = false;

  active_comment_tab: CommentTab = "public";
  can_see_tabs = false;

  constructor() {
    language.load_translations(comments_translations);
  }
  ngOnInit() {
    User.currentUserPromise.then(res=>{
        if (res.company_id == this.main_company_id || res.user_type_id === Task.USER_TYPE.SYSTEM_ADMIN) {
            this.can_see_tabs = true;
            this.active_comment_tab = MANAGER_TYPES.includes(res.user_type_id)
                ? "public"
                : "internal";
        }
    })

}

  ngOnChanges(changes: SimpleChanges) {
    this.get_comments(this.active_comment_tab);
  }

  scroll_to_bottom() {
    this.comments_container.nativeElement.scrollIntoView({
      behavior: 'smooth',
    });
  }

  async get_comments(tab: CommentTab) {
    this.active_comment_tab = tab;
    this.comments = [];

    if (this.entity && this.entity_id) {
      try {
        let promise = Comments.get(this.entity, this.entity_id)
        progress.listen('get_comments', promise);
        const res = await promise;
        if (res.status === 'success') {
          this.comments = res.data;
        }
      } catch (error) {
        console.error('Error', error);
      }
    }
  }

  async add_comment(e: Event) {
    e.preventDefault();

    if (this.entity && this.entity_id && this.comment_text.trim().length > 0) {
      try {
        await Comments.add(this.entity, this.entity_id, this.comment_text, this.active_comment_tab === 'internal');
        this.comment_text = '';

        await this.get_comments(this.active_comment_tab);

      } catch (error) {
        console.error('Error', error);
      }
    }
  }
}
